import React, { Component } from 'react';
import JobFullDetails from './job-full-details.jsx';
import PortalJobScheduler from '../job-scheduling/portal-job-scheduler.jsx';
import PortalJobUserTask from '../user-task/user-task-scheduler.jsx';
import RegNoteBox from './reg-note-box.jsx';
import { Animate } from 'react-simple-animate';
import moment from 'moment';
import ReactDOM from 'react-dom';
import Axios from 'axios';
export default class Job extends Component {
  constructor(props) {
    super(props);
    let that = this;
    this.state = { 
      showFullJobDetails: false,
      showUserTaskDetails: false,
      data: props.data || null,
      original: {
        distance_in_miles: props.data.distance_in_miles,
        estimated_duration: props.data.estimated_duration,
        job_price: props.data.job_price,
        driver_price: props.data.driver_price,
        invoice_number: props.data.invoice_number,
        subcontract_invoice_number:props.data.subcontract_invoice_number
      },
      showJobScheduler: false,
      showJobUserTaskScheduler: false,
      isLoading: !props.data,
      play: false,
      changeInvoiceNumberApiUrl: "/api/v1/portal/jobs/change-invoice-number/",
      changeSInvoiceNumberApiUrl: "/api/v1/portal/jobs/change-subcontract-invoice-number/",
      driverScreen:props.driverScreen || false,
      jobIndex:props.jobIndex || 0,
      jobIds:props.jobIds || [],
      groupWorkScreen:props.groupWorkScreen || false,
      isQuickDriverPlannScreen:false,
      isQuickDriverPlannScreenUserTask:false,
      isDiffDate:props.isDiffDate || false,
      firstLookPage:props.firstLookPage || false,
      showJobNoteBox: false,
      unplannedScreen:props.unplannedScreen || false,
      customerAllJobsPage:props.customerAllJobsPage || false,
      jobStatusLoading: false,
      hasThirdPartyObject: props.data.thirdparty ? (props.data.thirdparty.trax_exported_job_id ? true : false ) : false,
      hasThirdPartyObject: props.data.thirdparty,
      schedulePage: window.location.pathname == '/drivers/schedules' ? true : false,
      groupPlanningPage: window.location.pathname == '/planning/group-work' ? true : false,
    };
    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).listen(
      'JobsTableChanged',
      (e) => {
        that.setState({
          isLoading: true
        });
        that.getJobData();
      }
    );
    this.handleJobDistanceChange = this.
    handleJobDistanceChange.bind(this);
    this.handleJobEstimatedDurationChange = this.
    handleJobEstimatedDurationChange.bind(this);
    this.handleJobPriceChange = this.
    handleJobPriceChange.bind(this);
    this.handleDriverPriceChange = this.
    handleDriverPriceChange.bind(this);
    this.handleJobInvoiceNumberChange = this.
    handleJobInvoiceNumberChange.bind(this);
    this.handleJobSubcontractedInvoiceNumberChange = this.handleJobSubcontractedInvoiceNumberChange.bind(this);
    this.changeJobPrice = this.
    changeJobPrice.bind(this);
    this.handleSchedulerHide = this.
    handleSchedulerHide.bind(this);
    this.handleSchedulerHideUserTask = this.
    handleSchedulerHideUserTask.bind(this);
    this.handleMoveButtonClick = this.handleMoveButtonClick.bind(this);
    this.handleJobOrder = this.handleJobOrder.bind(this);
    this.handleArrayMove = this.handleArrayMove.bind(this);
    this.handleJobDataIndexes = this.handleJobDataIndexes.bind(this);
    this.handleIsQuickDriverPlannScreenClickAfterUpdate = this.handleIsQuickDriverPlannScreenClickAfterUpdate.bind(this);
    this.handleIsQuickDriverPlannScreenClickAfterUpdateUserTask = this.handleIsQuickDriverPlannScreenClickAfterUpdateUserTask.bind(this);
    this.handleHideRegNoteBox = this.handleHideRegNoteBox.bind(this);
    this.handleMorningETAJob = this.handleMorningETAJob.bind(this);
    this.logMorningETA = this.logMorningETA.bind(this);
  }
  componentWillUpdate(prevProps, prevState){
    /**
     * we can watch and prevent update old job status by matching prevStateStatus with currStateStatus
     * and same for  prePropStatus, currPropStatus if job status is not hold it's possition and revert 
     * it back to old status.
     * this happening only when we have multiple drivers and portal user try to make change.
     */
    // var d = new Date();
    // console.log(d.getMinutes(),d.getSeconds(),d.getMilliseconds());
    // console.info("prevProps job id "+prevProps.data.id, "prePropStatus" + prevProps.data.status, "currPropStatus" + this.props.data.status );
    // console.info("prevState job id "+prevState.data.id, "prevStateStatus" + prevState.data.status, "currStateStatus" + this.state.data.status);
    // Bugsnag.notify("prevState job id "+prevState.data.id + ",prevStateStatus" + prevState.data.status + "currStateStatus" + this.state.data.status);
    // console.dir(snapshot);
    // console.trace();
  }

  handleShowInitialsFormOnClick() {
    const { deliverBeforeEvening, deliverAfterEvening, is_closed_driver_deliver_notification, id } = this.state.data;
    const modalJobId = id;
    let modalType = '';
    if((!deliverAfterEvening || _.isUndefined(deliverAfterEvening)) && (!deliverBeforeEvening || _.isUndefined(deliverBeforeEvening))){
      return;
    }
    if(is_closed_driver_deliver_notification === 1){
      return;
    }
    if (deliverBeforeEvening && is_closed_driver_deliver_notification === 0) {
      modalType = 'deliverBeforeEvening'; 
    } else if (deliverAfterEvening && is_closed_driver_deliver_notification === 0) {
      modalType = 'deliverAfterEvening';
    }
    $('#job-estimated-time-confimation-modal').modal('show');
    if (document.getElementById('react-component-g4-logistics-portal-job-estimated-time-confimation-modal')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('react-component-g4-logistics-portal-job-estimated-time-confimation-modal'));
      ReactDOM.render(
        <>
        <div className="form-group">
          <div className="row">
            <div className="col-md-2">
                <label htmlFor={`confirmClose${modalType}Initials`} className="lblInitials">Initials</label>
            </div>
            <div className="col-md-9">
              <div className='form-group'>
                <textarea className="form-control" id={`confirmClose${modalType}Initials`} data-id={modalJobId} rows="3"></textarea>
              </div>
            </div>
          </div>
        </div>
        <button type="button" className="btn btn-primary" onClick={() => this.saveConfirmCloseInitials(modalJobId, modalType)}>Save</button>
        </>
        ,
        document.getElementById('react-component-g4-logistics-portal-job-estimated-time-confimation-modal')
      );
    }
  }
  saveConfirmCloseInitials = (jobId, type) => {
    $('.alertIntReq').remove();
    let initials = '';
    if(type=='deliverAfterEvening')
    {
      initials = document.getElementById("confirmClosedeliverAfterEveningInitials").value;
    }
    if(type=='deliverBeforeEvening')
    {
      initials = document.getElementById("confirmClosedeliverBeforeEveningInitials").value;
    }
    if(initials=="")
    {
      if(type=='deliverAfterEvening')
        {
          $('#confirmClosedeliverAfterEveningInitials').after('<div class="alert alert-danger alertIntReq"><strong>Required!</strong> Initials is required.</div>');
        }
      if(type=='deliverBeforeEvening')  
        {
          $('#confirmClosedeliverBeforeEveningInitials').after('<div class="alert alert-danger alertIntReq"><strong>Required!</strong> Initials is required.</div>');
        }
    }
    else {
      $('.alertIntReq').remove();
      // $('#lateDriverPopUpClose-'+jobId).remove();
      if(type=='deliverAfterEvening')
        {
          $('#jobs-table-row-' + jobId).find('.column-type-dropoff-to').removeClass('deliverAfterEvening').addClass('deliverAfterEveningWB');
        }
      if(type=='deliverBeforeEvening')  
        {
          $('#jobs-table-row-' + jobId).find('.column-type-dropoff-to').removeClass('deliverBeforeEvening').addClass('deliverBeforeEveningWB');
        }
       //tirck to hide model. but this will not gerentees that post request is served!!
        $('#job-estimated-time-confimation-modal').modal('hide');
        Axios.post('/api/v1/portal/jobs/set-delivery-postcode-notification', {
            api_token: window.api_token,
            data: {
                jobId: this.state.data.id,
                deliverExpectedArrivalTime: this.state.data.deliverExpectedArrivalTime,
                initials: initials
            }
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(() => {
            // console.log('done method called');
        }).catch(error => {
            console.error('Error:', error);
        });
    }
  }
  renderNotificationIcon = () => {
    const { deliverBeforeEvening, deliverAfterEvening, is_closed_driver_deliver_notification, id } = this.state.data;
    if ((deliverBeforeEvening || deliverAfterEvening) && is_closed_driver_deliver_notification === 0) {
      return (
          <i
            className="fas fa-times-circle lateDriverPopUpNotification"
            aria-hidden="true"
            id={`lateDriverPopUpClose-${id}`}
          ></i>
      );
    }
    return;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.applyColumnToggleSettings();
  }
  handleSchedulerHide(){
    this.setState({showJobScheduler: false});
  }
  handleSchedulerHideUserTask(){
    this.setState({showJobUserTaskScheduler: false});
  }
  componentDidMount() {
    this.calculateGrossProfitPercentage();
    this.applyColumnToggleSettings();
    this.setState({
      play: true
    });
    //  $('[data-toggle="tooltip"]').tooltip(); 
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      original: {
        distance_in_miles: nextProps.data.distance_in_miles,
        estimated_duration: nextProps.data.estimated_duration,
        job_price: nextProps.data.job_price,
        driver_price: nextProps.data.driver_price,
        invoice_number: nextProps.data.invoice_number,
        subcontract_invoice_number:nextProps.data.subcontract_invoice_number
      },
      jobIds:nextProps.jobIds,
      customerAllJobsPage:nextProps.customerAllJobsPage
    });
  }
  postData(url = ``, data = {}) {
    return fetch(url, {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token,
        "Accept": 'application/json'
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: JSON.stringify(data),
    });
  }
  updateJobStatus(jobId){
    this.setState({jobStatusLoading : true})
    let data = {'id' : jobId};
    this.postData(
      '/api/v1/portal/jobs/update-job-status-from-thirdparty', data).
    then(responseText => {
      let response = responseText.json();

      if(responseText.status==200)
      {
        response.then((response) => {
          this.setState(prevState => {
            let data = Object.assign({}, prevState.data);  // creating copy of state variable jasper
            data.status = response.job_status;                     // update the name property, assign a new value                 
            return { data };                                 // return new object jasper object
          }, () => {
            this.setState({jobStatusLoading : false})
            alert(response.message);
          })
        });
      } else {
        response.then((response) => {
          alert(response.message);
          this.setState({jobStatusLoading : false})
        });
      }
    }).catch(error => {
        console.log(error);
        this.setState({jobStatusLoading : false})
        // alert('Error saving job. Please check data and try again.');
    });
  }
  applyColumnToggleSettings() {
    let toggleSettings = window.jobs_table_column_toggle_settings;
    if (toggleSettings && this.state.data) {
      if (toggleSettings.job_number) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-number'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-number'
        ).style.display = "none";
      }
      if (toggleSettings.assigned_to) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-assigned-to'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-assigned-to'
        ).style.display = "none";
      }
      if (toggleSettings.company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-company'
        ).style.display = "none";
      }
      if (toggleSettings.original_company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-original-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-original-company'
        ).style.display = "none";
      }
      if (toggleSettings.subcontracted_by_company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-by-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-by-company'
        ).style.display = "none";
      }
      if (toggleSettings.subcontracted_to_company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-to-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-to-company'
        ).style.display = "none";
      }
      if (toggleSettings.required_pickup) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-required-pickup'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-required-pickup'
        ).style.display = "none";
      }
      if (toggleSettings.required_dropoff) {
        document.querySelector("#jobs-table-row-" +
          ""+this.state.data.id+' .column-type-required-dropoff'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-required-dropoff'
        ).style.display = "none";
      }
      if (toggleSettings.scheduled_pickup) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-pickup'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-pickup'
        ).style.display = "none";
      }
      if (toggleSettings.scheduled_dropoff) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-dropoff'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-dropoff'
        ).style.display = "none";
      }
      if (toggleSettings.reg) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-reg'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-reg'
        ).style.display = "none";
      }
      if (toggleSettings.size_of_vehicle) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-size_of_vehicle'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-size_of_vehicle'
        ).style.display = "none";
      }

      if (toggleSettings.vehicle_on_site) {
        document.querySelector('#jobs-table-row-'+
        this.state.data.id+' .column-type-vehicle-on-site'
        ).style.display = "flex";
      }
      else {
        document.querySelector('#jobs-table-row-'+
          this.state.data.id+' .column-type-vehicle-on-site'
        ).style.display = "none";
      }

      if (toggleSettings.customer) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer'
        ).style.display = "none";
      }
      if (toggleSettings.customer_job_number) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer-job-number'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer-job-number'
        ).style.display = "none";
      }
      if (toggleSettings.pickup_from) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-from'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-from'
        ).style.display = "none";
      }
      if (toggleSettings.pickup_town_city) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-town-city'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-town-city'
        ).style.display = "none";
      }
      if (toggleSettings.pickup_postcode) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-postcode'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-postcode'
        ).style.display = "none";
      }
      if (toggleSettings.dropoff_to) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-to'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-to'
        ).style.display = "none";
      }
      if (toggleSettings.dropoff_town_city) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-town-city'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-town-city'
        ).style.display = "none";
      }
      if (toggleSettings.dropoff_postcode) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-postcode'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-postcode'
        ).style.display = "none";
      }
      if (toggleSettings.driver) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver'
        ).style.display = "none";
      }
      if (toggleSettings.status) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-status'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-status'
        ).style.display = "none";
      }
      if (toggleSettings.distance_in_miles) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-distance-in-miles'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-distance-in-miles'
        ).style.display = "none";
      }
      if (toggleSettings.estimated_duration) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-estimated-duration'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-estimated-duration'
        ).style.display = "none";
      }
      if (toggleSettings.job_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-price'
        ).style.display = "none";
      }
      if (toggleSettings.driver_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-price'
        ).style.display = "none";
      }
      if (toggleSettings.expenses_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-expenses-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-expenses-price'
        ).style.display = "none";
      }
      if (toggleSettings.approved_expenses_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer-paid-expenses-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer-paid-expenses-price'
        ).style.display = "none";
      }

      if (toggleSettings.admin_fee) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-admin-fee'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-admin-fee'
        ).style.display = "none";
      }

      if (toggleSettings.g4_profit) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-g4-profit'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-g4-profit'
        ).style.display = "none";
      }

      if (toggleSettings.gross_profit_percentage) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-gross-profit-percentage'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-gross-profit-percentage'
        ).style.display = "none";
      }
      if (toggleSettings.invoice_month) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-month'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-month'
        ).style.display = "none";
      }
      if (toggleSettings.invoice_number) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-number'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-number'
        ).style.display = "none";
      }
      if (toggleSettings.subcontract_invoice_number) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-subcontract-invoice-number'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-subcontract-invoice-number'
        ).style.display = "none";
      }
      if (toggleSettings.driver_delivered_date) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-delivered-date'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-delivered-date'
        ).style.display = "none";
      }
      if (toggleSettings.confirmed_on_site) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-confirmed_on_site'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-confirmed_on_site'
        ).style.display = "none";
      }

      if (toggleSettings.full_details) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-full-details'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-full-details'
        ).style.display = "none";
      }
    }
  }
  getJobData() {
    if (this.state && this.state.data && this.state.data.id) {
      let url = '/api/v1/portal/jobs/view/' +this.state.data.id;
      if(this.state.groupWorkScreen){
         url = '/api/v1/portal/jobs/view/' +this.state.data.id+'/'+this.state.groupWorkScreen;
      }
      return fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          if(response.data[0]){
            this.setState({data: response.data[0],isLoading: false},()=>{
              // if(this.state.groupWorkScreen){
                
              //   $('html, body').animate({
              //       scrollTop: $("#jobs-table-row-"+this.state.data.id).offset().top - 100
              //   }, 1000);
              // } they dont want moving screen.
            });
          }
        });
      });
    }
  }
  showFullJobDetails(jobId) {
    let fullDetailsIcon = document.querySelector(
      '#fa-full-details-icon-'+jobId
    );
    fullDetailsIcon.classList.toggle('fa-level-down-alt');
    fullDetailsIcon.classList.toggle('fa-minus');
    document.querySelector(
      '.jobs-table-row-summary#jobs-table-row-'+jobId
    ).classList.toggle('bold');
    this.setState(
      {
        showFullJobDetails: !this.state.showFullJobDetails
      }
    );
  }
  showUserTaskDetails(jobId, task_id) {
    if (task_id != null) {
      setTimeout(function(){
        var element = document.getElementById("user_company_list"+jobId);
        var event = new Event("change", { bubbles: true });
        element.dispatchEvent(event);        
      },1000)
      setTimeout(function(){
        $("#user_task_list"+jobId).val(task_id).change();
      }, 3000);
    } else {
      $("#user_task_list"+jobId).val(0).change();
    }
    this.setState({showJobUserTaskScheduler: !this.state.showJobUserTaskScheduler});
  }
  changeDistanceInMiles(e) {
    let newDistanceInMiles = e.target.value;
    if (newDistanceInMiles === this.state.original.distance_in_miles) {
      return null;
    }
    let changeDistanceInMiles = confirm(
      'change Distance to '+ newDistanceInMiles + '?'
    );
    if (changeDistanceInMiles) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-distance-in-miles/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          distance_in_miles: newDistanceInMiles
        },
        cache: false,
        method: 'post',
      })
      .done(function(data) {
      //  alert('cancelled');
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=distance_in_miles]"
      ).val(
        this.state.data.distance_in_miles
      );
    }
  }
  changeEstimatedDuration(e) {
    let newEstimatedDuration = e.target.value;
    if (newEstimatedDuration === this.state.original.estimated_duration) {
      return null;
    }
    let changeEstimatedDuration = confirm(
      'change Duration to '+ newEstimatedDuration + '?'
    );
    if (changeEstimatedDuration) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-estimated-duration/"+
          this.state.data.id,
        data: {
          api_token: window.api_token,
          estimated_duration: newEstimatedDuration
        },
        cache: false,
        method: 'post',
      })
      .done(function(data) {
        // ?
      });
    }
    else {
      $(
        "#jobs-table-row-"+this.state.data.id+" input[name=estimated_duration]"
      ).val(
        this.state.data.estimated_duration
      );
    }
  }
  changeJobPrice(e) {
    let newJobPrice = this.state.data.job_price;
    if (newJobPrice === this.state.original.job_price) {
      return null;
    }
    let changeJobPrice = confirm('change JobPrice to £'+ newJobPrice + '?');
    let that = this;
    if (changeJobPrice) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-job-price/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          job_price: newJobPrice
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        that.calculateGrossProfitPercentage();
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=job_price]").
      val(e.target.value);
    }
  }
  changeDriverPrice(e) {
    let newDriverPrice = e.target.value;
    if (newDriverPrice === this.state.original.driver_price) {
      return null;
    }
    let changeDriverPrice = confirm(
      'change DriverPrice to £'+ newDriverPrice + '?'
    );
    let that = this;
    if (changeDriverPrice) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-driver-price/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          driver_price: newDriverPrice
        },
        cache: false,
        method: 'post',

      })
      .done(function() {
        that.calculateGrossProfitPercentage();
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=driver_price]").val(
        e.target.value
      );
    }
  }
  changeInvoiceNumber(e) {
    //console.log(this.state.original.invoice_number);
    let newInvoiceNumber = e.target.value;
    if (newInvoiceNumber === this.state.original.invoice_number) {
      return null;
    }
    let changeInvoiceNumber = confirm(
      'change InvoiceNumber to ' + newInvoiceNumber + '?'
    );
    if (changeInvoiceNumber) {
      let jobId = this.state.data.id;
      return fetch(
        this.state.changeInvoiceNumberApiUrl + this.state.data.id,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              invoice_number: document.getElementById(
                "job-" + jobId + "-invoice-number"
              ).value
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          // alert(response);
        });
      });
    }
    else {
      $(
        "#jobs-table-row-" +
        this.state.data.id +
        " input[name=invoice_number]"
      ).val(
        e.target.value
      );
    }
  }
  changeSubcontractInvoiceNumber(e) {
    let newSInvoiceNumber = e.target.value;
    if (newSInvoiceNumber === this.state.original.subcontract_invoice_number) {
      return null;
    }
    let changeInvoiceNumber = confirm(
      'change InvoiceNumber to ' + newSInvoiceNumber + '?'
    );
    if (changeInvoiceNumber) {
      let jobId = this.state.data.id;
      return fetch(
        this.state.changeSInvoiceNumberApiUrl + this.state.data.id,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              subcontract_invoice_number: document.getElementById(
                "job-" + jobId + "-subcontract-invoice-number"
              ).value
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          //
        });
      });
    }
    else {
      $(
        "#jobs-table-row-" +
        this.state.data.id +
        " input[name=subcontract_invoice_number]"
      ).val(
        e.target.value
      );
    }
  }
  handleQuickPlanButtonClick() {
    this.setState({showJobScheduler: !this.state.showJobScheduler});
  }
  handleRegButtonClick(){
    this.setState({showJobNoteBox: !this.state.showJobNoteBox});
  }
  handleHideRegNoteBox(){
    this.setState({showJobNoteBox: false});
  }
  handleIsQuickDriverPlannScreenClick() {
    this.setState({showJobScheduler: true,isQuickDriverPlannScreen:true});
  }
  handleIsQuickDriverPlannScreenClickUsesrTask() {
    this.setState({showJobUserTaskScheduler: true,isQuickDriverPlannScreenUserTask:true});
  }
  handleIsQuickDriverPlannScreenClickAfterUpdateUserTask() {
    this.setState({isQuickDriverPlannScreenUserTask:false});
  }
  handleIsQuickDriverPlannScreenClickAfterUpdate() {
    this.setState({isQuickDriverPlannScreen:false});
  }
  handleJobDistanceChange(e) {
    let newJobDistance = e.target.value;
    let data = {...this.state.data}
    data.distance_in_miles = newJobDistance;
    this.setState({data});
  }
  handleJobEstimatedDurationChange(e) {
    let newJobEstimatedDuration = e.target.value;
    let data = {...this.state.data}
    data.estimated_duration = newJobEstimatedDuration;
    this.setState({data});
  }
  handleJobPriceChange(e) {
    //console.log('handle Job Price In Pence Change');
    let pence = e.target.value;
    let newJobPrice = pence;
    let data = {...this.state.data}

    data.job_price = newJobPrice;
    this.setState({data});
  }
  handleDriverPriceChange(e) {
    //console.log('handle Driver Price In Pence Change');
    let newDriverPrice = e.target.value;
    let data = {...this.state.data};
    //console.log(e.target.value);
    data.driver_price = newDriverPrice;
    this.setState({data});
  }
  handleJobInvoiceNumberChange(e) {
    let newJobInvoiceNumber = e.target.value;
    let data = {...this.state.data};
    data.invoice_number = newJobInvoiceNumber;
    this.setState({data});
  }
  handleJobSubcontractedInvoiceNumberChange(e) {
    let newJobSInvoiceNumber = e.target.value;
    let data = {...this.state.data};
    data.subcontract_invoice_number = newJobSInvoiceNumber;
    this.setState({data});
  }
  handleMoveButtonClick(e,jobId,index){
    this.props.handleLoading(true);
    let row = document.querySelector('.jobs-table-row-'+jobId );
    $('#jobs-table-row-'+jobId).addClass('processing');
    let oldIndex = this.state.jobIds.indexOf(jobId);
    let currentIndex = index;
    let updatedJobIds = [];
    if ($(e.target).hasClass('fa fa-arrow-up move-up')){
        var $current = $(e.target).closest('.movejobs');
        var $previous = $current.prev('.movejobs');
        if($previous.length !== 0){
          currentIndex--;
          $current.insertBefore($previous);
            $('#jobs-table-row-'+jobId).removeClass('processing');
        }
        row.setAttribute('data-index',currentIndex);
        updatedJobIds = this.handleArrayMove(this.state.jobIds, oldIndex, currentIndex);        
        this.handleJobOrder(currentIndex,updatedJobIds);
        return false;
    }
    else{
        var $current = $(e.target).closest('.movejobs')
        var $next = $current.next('.movejobs');
        if($next.length !== 0){
            currentIndex++;
            $current.insertAfter($next);
            $('#jobs-table-row-'+jobId).removeClass('processing');
        }
        row.setAttribute('data-index',currentIndex);
        updatedJobIds = this.handleArrayMove(this.state.jobIds, oldIndex, currentIndex);
        this.handleJobOrder(currentIndex,updatedJobIds);
        return false;
    }    
  }
  handleJobOrder(order,updatedJobIds){
      let driverId = (this.state.data.driver_id!=null)?this.state.data.driver_id:this.state.data.saved_driver_id;
      let url = "/api/v1/portal/jobs/change-job-order/"+this.state.data.id+"/"+driverId;
      return fetch(
        url,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              order: order,
              jobs:updatedJobIds
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
           this.props.handler(response.data);
           this.props.handleLoading(false);
           $('#jobs-table-row-'+this.state.data.id).removeClass('processing');
        });
      });
  }
  handleArrayMove(arr, old_index, new_index){
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; 
  }
  handleJobDataIndexes(updatedJobIds){
      updatedJobIds.map((id,index)=>{
          $('.jobs-table-row-'+id).attr('data-index',index);
      });
  }
  handleSetCompanyForPlanning(e){
    $.ajax({
      url: "/api/v1/portal/jobs/set-planner-company/"+this.state.data.id,
      data: {
        api_token: window.api_token,
        selected_company: e.target.value
      },
      cache: false,
      method: 'post',
    })
    .done(function() {
      //
    });
  }
  handleSetQuickPrioritiseJob(e){
    $.ajax({
      url: "/api/v1/portal/jobs/set-quick-prioritise-job/"+this.state.data.id,
      data: {
        api_token: window.api_token,
        quick_prioritise: e.target.value
      },
      cache: false,
      method: 'post',
    })
    .done(function() {
      //
    });
  }
  calculateGrossProfitPercentage() {
    let jobTotalPrice = parseFloat(this.state.data.job_price);
    let jobTotalCosts = parseFloat(this.state.data.expenses_price) +
                        parseFloat(this.state.data.driver_price);
    let grossProfit = jobTotalPrice - jobTotalCosts;
    let grossProfitOverTotal = grossProfit / jobTotalPrice;
    
    //profit cal
    let dPrice = parseFloat(this.state.data.driver_price);
    let ePrice = parseFloat(this.state.data.expenses_price);
    let adminFPrice = (this.state.data.admin_fee_in_pence) ? (parseFloat(this.state.data.admin_fee_in_pence)) / 100 : 0.00;
    let customerPaidExpensesPrice = parseFloat(this.state.data.customer_paid_expenses_price);
    let jobProfit = ((jobTotalPrice) - (adminFPrice) - (dPrice)  - (customerPaidExpensesPrice)).toFixed(2);

    let grossProfitPercentage = (jobProfit/jobTotalPrice) * 100;

    this.setState({
      grossProfitPercentage: grossProfitPercentage.toFixed(2),
      jobProfit:jobProfit
    });
  }
  enterPressed(event) {
    let code = event.keyCode || event.which;
    if (code === 13) { // [ Enter ]
      $(event.target).trigger('blur');
    }
  }

  isLightColor(hex) {
    const rgb = parseInt(hex.substring(1), 16); // Convert hex to RGB
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    // Use a simple formula to determine if the color is light
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155; // Adjust threshold as needed
  }
  handleMorningETAJob() {
    const { data } = this.state;
    const today = moment().format('YYYY-MM-DD'); 
    const dropoffDate = moment(data?.scheduled_dropoff_date); 

    const isToday = dropoffDate.isSame(today, 'day');
    const isBeforeMorningEnd = dropoffDate.isBefore(moment().set({ hour: 8, minute: 46 }), 'minute');
    const isInprogressJob = !['completed', 'cancelled', 'aborted', 'deleted'].includes(data?.status); 
    const isPassedMorningEta = moment().isAfter(moment().set({ hour: 8, minute: 46 }), 'minute');
    const is_morning_ETA = Boolean(data?.is_morning_ETA);
    return (isToday &&
      isBeforeMorningEnd && 
      isInprogressJob &&
      isPassedMorningEta && 
      is_morning_ETA
      ); 
  }

  logMorningETA() {
    let morningETAReason = prompt("Please enter reason:");
    if (morningETAReason !== null && morningETAReason.trim() !== "") {
      let url = "/api/v1/portal/jobs/disable-morning-eta";
  
      return fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": 'application/json'
        },
        body: JSON.stringify({
          reason: morningETAReason,
          jobId: this.state.data.id
        })
      })
      .then(res => res.json())
      .then(response => {
      })
      .catch(error => {
        console.error("Error:", error);
      });
    }
  }
  render() {
    if (!this.state.data) {
      return false;
    }
    let customerAllJobsPage = this.state.customerAllJobsPage;
    let hasSplitParent = (
          this.state.data.split_parent_id > 0 &&
          this.state.data.is_split_job
        ),
        isSplitJob = this.state.data.is_split_job,
        hasSplitJobs = this.state.data.has_split_jobs,
        isSplitJobPartA = this.state.data.split_sequence === 1,
        isSplitJobPartB = this.state.data.split_sequence === 2,
        SplitJobColumnLabel = <span className="text-decorate-split-job">
                                split job
                              </span>;
        let assignedToDriverAt = this.state.data.assigned_to_driver_at,
            diffInMinute = 0;
        if(assignedToDriverAt != null){
            let assignedAt = moment(assignedToDriverAt);
            let currentTime = moment(new Date());
            diffInMinute =  currentTime.diff(assignedAt, 'minutes');
        }
        let requiredPickupDate = this.state.data.pickup_year+'-'+this.state.data.pickup_month+'-'+this.state.data.pickup_day;
        let requiredDropoffDate = this.state.data.dropoff_year+'-'+this.state.data.dropoff_month+'-'+this.state.data.dropoff_day;
        let JobIsDue48Hours = false;
        let turnsJobToRedP = false;
        let turnsJobToRedD = false;
        let turnsJobToRedDG = false;
        let pickupTime = ['?','am','pm','anytime','asap'];
        let requiredDropoffDateG = this.state.data.dropoff_year+'-'+this.state.data.dropoff_month+'-'+this.state.data.dropoff_day+' '+this.state.data.dropoff_time; 
        if(requiredPickupDate != "" || requiredPickupDate != null){
          let today = moment(),now = moment();
           /* check if job is not allocated to driver and due withing 2 days turns it into blue */
          JobIsDue48Hours = moment(requiredPickupDate).isBetween((today.format('Y-M-D')), (today.add({hours:31,minutes:30}).format('Y-M-D')), null, '[]');
          /* check if job date passed away than turns it into red */
          turnsJobToRedP = moment(requiredPickupDate).isBefore(now.format('Y-M-D'));
        }
        if(requiredDropoffDate != "" || requiredDropoffDate != null){
          let now = moment();
          turnsJobToRedD = moment(requiredDropoffDate).isBefore(now.format('Y-M-D'));
        }
        if(requiredDropoffDateG != "" || requiredDropoffDateG != null || requiredDropoffDateG != "?-?-?" || requiredDropoffDateG != "?-?-? ?"){
          if(pickupTime.indexOf(this.state.data.dropoff_time) != -1){
            let now = moment();
            requiredDropoffDateG = this.state.data.dropoff_year+'-'+this.state.data.dropoff_month+'-'+this.state.data.dropoff_day; 
            turnsJobToRedDG = moment(requiredDropoffDateG).isBefore(now.format('Y-M-D'));
          }else{
            let now = moment();
            requiredDropoffDateG = this.state.data.dropoff_year+'-'+this.state.data.dropoff_month+'-'+this.state.data.dropoff_day; 
            turnsJobToRedDG = moment(requiredDropoffDateG).isBefore(now.format('Y-M-D'));
            if(turnsJobToRedDG){
              turnsJobToRedDG =( (this.state.data.dropoff_time) < (now.format('HHmm') )) ? true : turnsJobToRedDG;
            }
          }
        }
        let jobClass = "";
        if(this.state.isDiffDate){
          jobClass = "movejobs jobs-table-row-"+this.state.data.id+" "+"is-diff-date-grouped-jobs";
        }else{
          jobClass = "movejobs jobs-table-row-"+this.state.data.id;
        }

        /* disable other company job button*/ 
        let loggedInCompany = $('#data-compnay-id').attr('data-compnay-id');
        let allowOrDisallowDriverButton = (this.state.groupWorkScreen && this.state.data.company_id != loggedInCompany) ? true  :false;
        let allowOrDisallowQuickLoookButton = (this.state.firstLookPage && this.state.data.company_id != loggedInCompany) ? true  :false;
        const { dropoff_address, deliverExpectedArrivalTime, deliverAfterEvening, deliverBeforeEvening } = this.state.data;
        let colors = '';
        if (this.state.data.driver?.color_tag != null) {
          if (this.isLightColor(this.state.data.driver.color_tag)) {
            colors = '#000000';
          } else {
            colors = '#ffffff';
          }
        }
    return (
        <div className={jobClass} data-index={this.state.jobIndex}>      
        <Animate play={this.state.play} start={{opacity: 0}} end={{opacity: 1}}>
        <div className="jobs-table-row-container">
          <div
            className={
              "jobs-table-row jobs-table-row-summary row-status-bg-"+
              this.state.data.status+" "+
              ((this.state.data.driver_id != null) ?
                ' row-status-bg-sent-to-driver ' : '')+
              ((this.state.data.driver_id != null && this.state.data.status == 'inactive' && diffInMinute >= 30 ) ?
                ' row-status-bg-sent-to-driver-but-not-accepted ' : '')+
                ((this.state.data.checked === 1) ?
                  ' row-status-bg-green-important ' : '')+
              ((this.state.data.needs_planning_asap === 1) ?
                ' row-status-bg-cyan-important ' : '')+
              ((this.state.data.does_not_require_planning_yet === 1) ?
                ' row-status-bg-grey-important ' : '')+
              ((this.state.data.prechecked === 1) ?
                ' row-status-bg-prechecked ' : '')+
              ((this.state.data.has_a_major_issue === 1) ?
                ' row-status-bg-has-a-major-issue' : '')+
              ((this.state.data.has_an_issue === 1) ?
                  ' has-an-issue' : '')+
              ((JobIsDue48Hours && this.state.groupWorkScreen && this.state.data.driver_id == null) ? ' late-48-hours-due-job-'+JobIsDue48Hours : '')+
              (( (turnsJobToRedP || turnsJobToRedD) && this.state.groupWorkScreen && this.state.data.driver_id == null) ? ' past-job-not-collected' : '')+
              (( (turnsJobToRedDG) && this.state.groupWorkScreen && this.state.data.driver_id == null) ? ' past-job-not-collected-blue' : '')+
              (( this.state.data.thirdparty) ? ' row-status-bg-thirdparty-job' : '') 
            }
            id={
              "jobs-table-row-"+
              this.state.data.id
            }
          >
           { this.state.driverScreen ?
            <div className="cell column-type-order">
                <button className='move' title='Move Up' onClick={(e) => this.handleMoveButtonClick(e,this.state.data.id,this.state.jobIndex)}>
                    <i className="fa fa-arrow-up move-up"></i>
                </button>
                <button className='move' title='Move Down' onClick={(e) => this.handleMoveButtonClick(e,this.state.data.id,this.state.jobIndex)}>
                    <i className="fa fa-arrow-down move-down"></i>
                </button>
            </div>:''
            }
            <div className={`cell column-type-job-number pos-rel" ${this.handleMorningETAJob() ? 'late-morning-warn' : ''}`}>
            <a id={`job-${this.state.data.id}`} href={"/jobs/view/"+this.state.data.id}>
                {
                  this.state.data.id
                }
              </a>
              {
                (isSplitJob) ?
                  <i
                    className="fa fa-strikethrough split-job-status-is-split-job"
                    title={"job #"+this.state.data.id+
                    " is a Split Job, belongs to job#"+
                     this.state.data.split_parent_id+
                     (isSplitJobPartA ?
                       " (is SplitJob PartA)" :
                       " (is SplitJob PartB)")
                    }
                  >
                  </i>
                  : null
              }
              {
                (hasSplitJobs) ?
                  <i
                    className="fa fa-strikethrough split-job-status-has-split-jobs"
                    title="this job has been split into other jobs"
                  >&nbsp;</i>
                  : null
              }
              { 
                (this.state.data.thirdparty) ? 
                  <p className="thirdparty-job mb-0"> 
                    { (this.state.data.thirdparty.trax_imported_job_id) ? <i className="fa fa-reply"></i> : null} 
                    { (this.state.data.thirdparty.trax_exported_job_id) ? <i className="fa fa-share"></i> : null} 
                     &nbsp;
                    {(this.state.data.driver_id == 2394 ) ? <i className="fa-solid fa-truck"></i> :  <strong>G</strong>}                   
                  </p> 
                : null 
              }
              {this.handleMorningETAJob() && (
                <i
                  className="fa fa-times close-icon"
                  aria-hidden="true"
                  onClick={this.logMorningETA}
                  style={{ position: 'absolute', right: '10px', top: '12px', transform: 'translateY(-50%)', cursor: 'pointer', zIndex:'1' }}
                ></i>
              )}
            </div>
              {
                (this.state.customerAllJobsPage) ?
                  <div className="cell column-type-subcontracted-to-company-customer">
                    {(this.state.data.subcontracted_to_company &&
                      this.state.data.subcontracted_to_company.short_name)
                      ? this.state.data.subcontracted_to_company.short_name : ''
                    }
                  </div>
                  : null
              }
            <div className="cell column-type-assigned-to">
              <button
                  className="btn btn-dark btn-sm"
                  onClick={() => {
                    this.showUserTaskDetails(this.state.data.id,this.state.data.task_user_id)}
                  }
                >
                User task <i
                  className="fa fa-user"
                  id={"fa-full-details-icon-"+this.state.data.id}>
                </i>
                </button>
            </div>
            <div className="cell column-type-company">
              {((this.state.data.company)&&(this.state.data.company.short_name))?this.state.data.company.short_name:''}
            </div>
            <div className="cell column-type-original-company">
              {(this.state.data.original_company &&
                this.state.data.original_company.short_name)
                ? this.state.data.original_company.short_name : ''
              }
            </div>
            <div className="cell column-type-subcontracted-by-company">
              {(this.state.data.subcontracted_by_company &&
                this.state.data.subcontracted_by_company.short_name)
                ? this.state.data.subcontracted_by_company.short_name : ''
              }
            </div>
            <div className="cell column-type-subcontracted-to-company">
               {(this.state.data.subcontracted_to_company &&
                this.state.data.subcontracted_to_company.short_name)
                ? this.state.data.subcontracted_to_company.short_name : ''
              }
            </div>
             <div className={"cell column-type-required-pickup"+(
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' split-job-part-b-requested-pickup-time ' :
                 ' split-job-part-a-requested-pickup-time '
               ):''
             )}>
             {this.state.data.pickup_day}/
             {this.state.data.pickup_month}/
             {this.state.data.pickup_year} {
               this.state.data.pickup_time.toUpperCase()
             }
             </div>
             <div
               className={
                 "cell column-type-required-dropoff"+
                 (
                   (isSplitJob === true) ? (
                    (isSplitJobPartB === true) ?
                     ' split-job-part-b-requested-dropoff-time ' :
                     ' split-job-part-a-requested-dropoff-time '
                   ):''
                 )
               }
             >
               {this.state.data.dropoff_day}/
               {this.state.data.dropoff_month}/
               {this.state.data.dropoff_year} {
                 this.state.data.dropoff_time.toUpperCase()
               }
             </div>
             <div className={"cell column-type-scheduled-pickup"+
             (
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' split-job-part-b-scheduled-pickup-time ' :
                 ' split-job-part-a-scheduled-pickup-time '
               ):''
             )}>
                <span className={this.state.data.on_strict_schedule ? 'row-status-non-electric-vehicle row-status-bg-reg-main-span' : 'row-status-bg-reg-main-span'}>
                {this.state.data.on_strict_schedule ? (
                  <i className="fas fa-clock text-dark pl-2" style={{fontSize:'10px'}}></i>
                ):null}
                  <i className={this.state.data.on_strict_schedule ? 'row-status-non-electric-vehicle-italic' : ''}></i>
                  <span className='row-status-bg-reg-number-class'>
                    
                  {
                    (hasSplitJobs) ?
                      SplitJobColumnLabel
                      : null
                  }
                  {
                    (!hasSplitJobs &&
                      (this.state.data.scheduled_pickup_preposition !== null)) ?
                      <span className="pl-2">
                        {this.state.data.scheduled_pickup_day}/
                        {this.state.data.scheduled_pickup_month}/
                        {this.state.data.scheduled_pickup_year} {
                          (this.state.data.scheduled_pickup_time ?? '').toUpperCase()
                        }</span>
                      : null
                  }
                  {
                    (!hasSplitJobs &&
                      (this.state.data.scheduled_pickup_preposition === null)) ?
                      <span className="alert alert-danger not-planned-quick-plan-button"
                        onClick={(e) => this.handleQuickPlanButtonClick(e)}
                      >
                        Not Scheduled&nbsp;
                        <i className="fa fa-exclamation"></i>
                      </span>
                      : null
                  }

                  </span>
                </span>
             
             </div>


            <div className={"cell column-type-scheduled-dropoff"+(
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' split-job-part-b-scheduled-dropoff-time ' :
                 ' split-job-part-a-scheduled-dropoff-time '
               ):''
             )}>
              <span className={this.state.data.on_strict_schedule ? 'row-status-non-electric-vehicle row-status-bg-reg-main-span' : 'row-status-bg-reg-main-span'}>
                {this.state.data.on_strict_schedule ? (
                  <i className="fas fa-clock text-dark pl-2" style={{fontSize:'10px'}}></i>
                ): null}
                  <i className={this.state.data.on_strict_schedule ? 'row-status-non-electric-vehicle-italic' : ''}></i>
                  <span className='row-status-bg-reg-number-class'>
                    
                    {
                      (hasSplitJobs) ?
                      SplitJobColumnLabel
                      :
                    null
                    }
                    {
                      (!hasSplitJobs &&
                       (this.state.data.scheduled_dropoff_preposition !== null)) ?
                        <span className="pl-2">
                          {this.state.data.scheduled_dropoff_day}/
                          {this.state.data.scheduled_dropoff_month}/
                          {this.state.data.scheduled_dropoff_year} {
                            (this.state.data.scheduled_dropoff_time ?? '').toUpperCase()
                          }</span>
                        : null
                    }
                    {
                      (!hasSplitJobs &&
                       (this.state.data.scheduled_dropoff_preposition === null)) ?
                      <span
                        disabled={allowOrDisallowDriverButton}
                        className={(allowOrDisallowDriverButton) ? "alert alert-danger not-planned-quick-plan-button disable_pointer_event" : "alert alert-danger not-planned-quick-plan-button"}
                        onClick={
                          (e) => this.handleQuickPlanButtonClick(e)
                        }
                      >
                       Not Scheduled&nbsp;
                       <i className="fa fa-exclamation"></i>
                    </span>
                    : null
                   }


                  </span>
              </span>
            </div>
            
            { (this.state.firstLookPage || this.state.unplannedScreen) ? 
              <div className="cell column-quick-prioritise">
                <select className={"form-control form-control quick-prioritise-dropdown "+this.state.data.quick_prioritise} value={this.state.data.quick_prioritise} onChange={(e) => this.handleSetQuickPrioritiseJob(e)}>
                  <option value="-">-</option>
                  <option value="priority">Priority</option>
                  <option value="available">Available</option>
                </select>
              </div>
              : ""}
              
            <div
                className={
                  this.state.data.reg_note
                    ? "cell column-type-reg user-click-event red-bg"
                    : "cell column-type-reg user-click-event"
                }
                data-toggle="tooltip"
                data-placement="right"
                data-original-title={this.state.data.reg_note}
              >
                <span onClick={(e) => this.handleRegButtonClick(e)}
                className={this.state.data.vehicle && this.state.data.vehicle.fuel_type !== 'electric' ? 'row-status-non-electric-vehicle row-status-bg-reg-main-span' : 'row-status-bg-reg-main-span'}
                >
                  {this.state.data.vehicle &&
                  this.state.data.vehicle.fuel_type === 'electric' && (
                    <i className="fas fa-bolt fa-2x text-dark "></i>
                  )}
                  <i className={this.state.data.vehicle && this.state.data.vehicle.fuel_type !== 'electric' ? 'row-status-non-electric-vehicle-italic' : ''}></i>
                  {(this.state.unplannedScreen || this.state.schedulePage || this.state.groupPlanningPage || this.state.groupWorkScreen || this.state.groupPlanningPage) && 
                  (this.state.data.appraisal_to_be_done_on_external_system != null && this.state.data.appraisal_to_be_done_on_external_system !== undefined) && 
                  (this.state.data.name_of_external_system_for_appraisal != null && this.state.data.name_of_external_system_for_appraisal !== undefined) &&
                  (this.state.data.name_of_external_system_for_appraisal.toLowerCase() === 'model') ? (
                      <span>
                          <img src="/images/m_symbol.png" className="img-responsive reg_img_MoDel" alt="Symbol"/>
                      </span>
                  ) : ''}
                  <span className='row-status-bg-reg-number-class'>
                    {this.state.data.vehicle && this.state.data.vehicle.registration_number ? this.state.data.vehicle.registration_number : ""}
                  </span>
                </span>
            </div>


            <div className="cell column-type-size_of_vehicle">
              {this.state.data.vehicle?.size_of_vehicle}
            </div>
            <div className="cell column-type-vehicle-on-site">
              {this.state.data.vehicle_on_site}
            </div>
            <div className="cell column-type-customer">
              <a href={"/portal-admin/customers/view/"+
              this.state.data.customer.id}>
                {this.state.data.customer.name}
              </a>
            </div>
            <div className="cell column-type-customer-job-number">
                {this.state.data.customer_job_number}
            </div>
            <div
              className={
                "cell column-type-pickup-from"+
                (
                  (isSplitJob === true) ? (
                   (isSplitJobPartA === true) ?
                    ' split-job-part-a-pickup ' :
                    ' split-job-part-b-pickup '
                  ):''
                )+
                (
                  (hasSplitJobs === true) ? (
                    ' split-job-parent-pickup '
                  ):''
                )
              }
               title={
                 (
                   (isSplitJob === true) ? (
                  (isSplitJobPartA === true) ?
                   ' SplitJob PartA Pickup Locked ' :
                   ' This is SplitJob PartB Pickup. '+
                    'Should match SplitJob PartA Dropoff. '
                 ):''
               )+
               (
                 (hasSplitJobs === true) ? (
                   ' SplitJob Parent Pickup Locked '
                 ):''
               )
               }
            >
              {(this.state.data.pickup_address) ? this.state.data.pickup_address.town_city :''} {
                (this.state.data.pickup_address && this.state.data.pickup_address.postcode !== null) ?
                this.state.data.pickup_address.postcode.toUpperCase():''
              }
            </div>
            <div className="cell column-type-pickup-town-city">
              {(this.state.data.pickup_address) ? this.state.data.pickup_address.town_city : ''}
            </div>
            <div className="cell column-type-pickup-postcode">
              {(this.state.data.pickup_address) ? this.state.data.pickup_address.postcode : ''}
            </div>
            <div
              className={
                `cell column-type-dropoff-to ${
                  !deliverAfterEvening
                    ? ''
                    : this.state.data.is_closed_driver_deliver_notification === 0
                      ? 'deliverAfterEvening'
                      : 'deliverAfterEveningWB'
                }
                ${
                  !deliverBeforeEvening
                    ? ''
                    : this.state.data.is_closed_driver_deliver_notification === 0
                      ? 'deliverBeforeEvening'
                      : 'deliverBeforeEveningWB'
                }`+
               (
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' SplitJob PartB Dropoff Locked ' :
                 ' This is SplitJob PartA Dropoff. '+
                  'Should match SplitJob PartB Pickup.'
               ) : ''
             )+
             (
               (hasSplitJobs === true) ? (
                 ' SplitJob Parent Dropoff Locked. '
               ) : ''
             )
            }
            data-toggle="tooltip"
            data-placement="right"
            data-original-title={deliverExpectedArrivalTime}
            onClick={() => {this.handleShowInitialsFormOnClick()}}
            >
              { (this.state.data.dropoff_address) ? this.state.data.dropoff_address.town_city : ''}  {
                (this.state.data.dropoff_address && this.state.data.dropoff_address.postcode !== null) ?
                this.state.data.dropoff_address.postcode.toUpperCase():''
              }
              {/* {this.renderNotificationIcon()} */}
            </div>
            <div className="cell column-type-dropoff-town-city">
              {(this.state.data.dropoff_address) ? this.state.data.dropoff_address.town_city : ''}
            </div>
            <div className="cell column-type-dropoff-postcode">
            {dropoff_address ? dropoff_address.postcode : ''}
          </div>
            { (this.state.firstLookPage) ? 
              <div className="cell column-quick-job-from">
                {this.state.data.quick_job_from}
              </div>
              : ""}
            { (this.state.firstLookPage) ? 
              <div className="cell column-quick-job-to">
                {this.state.data.quick_job_to}
              </div>
            : ""}
            <div className="cell column-type-driver" style={{ backgroundColor: this.state.data.driver?.color_tag, color: colors }}>
              {
                (hasSplitJobs) ?
                SplitJobColumnLabel
                : null
              }
              {
                this.state.data.driver !== null && !hasSplitJobs ? (
                  <span
                    className={
                      allowOrDisallowDriverButton
                        ? "jobs-table-row-driver-name disable_pointer_event"
                        : "jobs-table-row-driver-name"
                    }
                    disabled={allowOrDisallowDriverButton}
                  >
                    {this.state.data.driver.user?.first_name + ' ' +
                    this.state.data.driver.user?.last_name}
                  </span>
                ) : null
              }
              {
                (this.state.data.saved_driver !== null &&
                this.state.data.driver === null &&
                  !hasSplitJobs) ?
                  <span disabled={allowOrDisallowDriverButton}
                    className={
                      (this.state.groupWorkScreen ? 
                        ((allowOrDisallowDriverButton) ?
                        'jobs-table-row-driver-name pencilled-in-driver planned-job-driver penciled-driver-in-bg-orange disable_pointer_event' 
                    : 'jobs-table-row-driver-name pencilled-in-driver planned-job-driver penciled-driver-in-bg-orange')
                    :'jobs-table-row-driver-name pencilled-in-driver planned-job-driver')
                    } 
                    onClick={(e) => this.handleIsQuickDriverPlannScreenClick(e)}>
                    {(this.state.data.saved_driver &&
                      this.state.data.saved_driver.user) ?
                      (this.state.data.saved_driver.user.first_name + ' ' +
                        this.state.data.saved_driver.user.last_name) : ' ERROR '
                    }
                  </span>
                    : null
              }
              {
                (this.state.data.driver === null &&
                this.state.data.saved_driver === null &&
                  !hasSplitJobs) ?
                <span
                  className={(allowOrDisallowDriverButton) ? "alert alert-danger not-planned-quick-plan-button disable_pointer_event" : "alert alert-danger not-planned-quick-plan-button" }
                  onClick={(e) => this.handleQuickPlanButtonClick(e)}
                  disabled={allowOrDisallowDriverButton}
                >
                  No Driver <i className="fa fa-exclamation">&nbsp;</i>
                </span>
                : null
              }
            </div>
            { this.state.groupWorkScreen ? 
             <div className="cell column-type-company">
              <select className="form-control form-control" value={this.state.data.selected_company} onChange={(e) => this.handleSetCompanyForPlanning(e)}>
                <option value="-">-</option>
                <option value="acv">ACV</option>
                <option value="acv-truck">ACV-TRUCK</option>
                <option value="bvl">BVL</option>
                <option value="cnd">CND</option>
                {/* <option value="g4">G4</option> */}
                <option value="sccd">SCCD</option>
                <option value="link">LINK</option>
              </select>
            </div>
            : ""}
            <div
              className={
                "cell column-type-status status-bg-"+
                this.state.data.status
              }
            >
            {this.state.jobStatusLoading ?
                  <div>
                    Please wait...
                  </div>
                  :
                  (this.state.data.status === 'completed_awaiting_data') ?
                    'completed, awaiting data' :
                    this.state.data.status
            }
            {'\u00A0'} {'\u00A0'}
            { this.state.hasThirdPartyObject ?
              <a title="update job status" className="update_job_status"
              onClick={() => this.updateJobStatus(this.state.data.id)}>
                <i className="fa fa-lg fa-sync"></i>
              </a>
              : ''
            }
            </div>
            <div className="cell column-type-distance-in-miles">
              <span className="cell-label">
              <input type="text" className="jobs-table-editable"
              value={this.state.data.distance_in_miles}
              onChange={this.handleJobDistanceChange}
              onBlur={(e) => this.changeDistanceInMiles(e)}
              onKeyUp={this.enterPressed.bind(this)}
              name="distance_in_miles" />
              </span>
            </div>
            <div className="cell column-type-estimated-duration">
            {
              (hasSplitJobs) ?
              SplitJobColumnLabel
              :
                <span className="cell-label">
              <input type="text" className="jobs-table-editable"
              value={this.state.data.estimated_duration}
              onChange={this.handleJobEstimatedDurationChange}
              onBlur={(e) => this.changeEstimatedDuration(e)}
              onKeyUp={this.enterPressed.bind(this)}
              name="estimated_duration" />
              </span>
            }
            </div>
            <div className="cell column-type-job-price">
            <span className="cell-label pound-sign-label">
            <input type="text" className="jobs-table-editable"
            value={this.state.data.job_price}
            onBlur={(e) => this.changeJobPrice(e)}
            onChange={this.handleJobPriceChange}
              onKeyUp={this.enterPressed.bind(this)}
            name="job_price" />
            </span>

            </div>
            <div className="cell column-type-driver-price">
            {
              (hasSplitJobs) ?
              SplitJobColumnLabel
              :
              <span className="cell-label pound-sign-label">
              <input type="text" className="jobs-table-editable"
              value={this.state.data.driver_price}
              onBlur={(e) => this.changeDriverPrice(e)}
              onChange={this.handleDriverPriceChange}
              onKeyUp={this.enterPressed.bind(this)}
              name="driver_price" />
              </span>
            }
            </div>
            <div className="cell column-type-expenses-price">
              <span className="cell-label pound-sign-label">
                {this.state.data.expenses_price}
              </span>
            </div>
            <div className="cell column-type-customer-paid-expenses-price">
              <span className="cell-label pound-sign-label">
                {this.state.data.customer_paid_expenses_price}
              </span>
            </div>
            <div className="cell column-type-admin-fee">
               &pound;{
                this.state.data.admin_fee_in_pence / 100
              }
            </div>
            <div className="cell column-type-g4-profit">
              &pound; {this.state.jobProfit}
            </div>
            <div className={"cell column-type-gross-profit-percentage " + (
              (this.state.grossProfitPercentage < 25) ?
              'less-than-25' :
              'more-than-25'
            )}>
              {this.state.grossProfitPercentage}%
            </div>
            <div className="cell column-type-invoice-month">
              {
                this.state.data.driver_completed_at ?
                  moment(
                    this.state.data.driver_completed_at
                  ).format(
                    'MMMM'
                  ).toString()
                  :
                  '?'
              }
            </div>
            <div className="cell column-type-invoice-number">
              <span className="cell-label">
              <input
                type="text"
                className="jobs-table-editable"
                value={this.state.data.invoice_number}
                onChange={this.handleJobInvoiceNumberChange}
                onBlur={(e) => this.changeInvoiceNumber(e)}
                onKeyUp={this.enterPressed.bind(this)}
                placeholder="invoice #"
                name="invoice_number"
                id={"job-" + this.state.data.id + "-invoice-number"}
              />
              </span>
            </div>
            <div className={(!this.state.groupWorkScreen) ? "cell column-type-subcontract-invoice-number": "cell column-type-subcontract-invoice-number hide-subcotract-invoice-number"}>
              <span className="cell-label">
              <input
                type="text"
                className="jobs-table-editable"
                value={this.state.data.subcontract_invoice_number}
                onChange={this.handleJobSubcontractedInvoiceNumberChange}
                onBlur={(e) => this.changeSubcontractInvoiceNumber(e)}
                onKeyUp={this.enterPressed.bind(this)}
                placeholder="subcontract invoice #"
                name="subcontract_invoice_number"
                id={"job-" + this.state.data.id + "-subcontract-invoice-number"}
              />
              </span>
            </div>
            <div className="cell column-type-driver-delivered-date">
                { (this.state.data.driver_completed_at != null) ? moment(this.state.data.driver_completed_at).format('DD/MM/YY').toString() : "?"}
            </div>
            <div className={
                            this.state.data.is_not_ready_confirmed_on_site === 1
                              ? 'cell column-type-confirmed_on_site bg-red'
                              : this.state.data.confirmed_on_site
                              ? 'cell column-type-confirmed_on_site bg-green'
                              : this.state.data.status !== 'completed' &&
                                this.state.data.status !== 'driving' &&
                                this.state.data.status !== 'split_job'
                              ? 'cell column-type-confirmed_on_site red-alert'
                              : 'cell column-type-confirmed_on_site'
                          }
            >
            { (this.state.data.is_not_ready_confirmed_on_site === 1) ? 'N' : ((this.state.data.confirmed_on_site) ? 'Y' : "") }
            </div>

            <div className="cell column-type-full-details">
              {(this.state.firstLookPage) ? 
                 (allowOrDisallowQuickLoookButton == false) ?
                <a className="btn btn-primary btn-sm" href={"/add-new-job/"+this.state.data.id}>Quick Look</a> : ""
                : 
                <button
                  className="btn btn-dark btn-sm"
                  onClick={() => {
                    this.showFullJobDetails(this.state.data.id)}
                  }
                >
                full details <i
                  className="fa fa-level-down-alt"
                  id={"fa-full-details-icon-"+this.state.data.id}>
                </i>
                </button>
              }
            </div>
          </div>
          {this.state.showJobScheduler ?
            <div className="job-scheduler-container">
              <button
                className="btn btn-lg btn-danger close-job-scheduler-button"
                onClick={(e) => {
                this.setState({
                  showJobScheduler: !this.state.showJobScheduler
                });
              }}>-</button>
              <PortalJobScheduler
                jobId={this.state.data.id}
                data={this.state.data}
                isLoading={false}
                schedulerHide={this.handleSchedulerHide}
                hasAssignedDriver={(this.state.data.driver !== null && !hasSplitJobs) ? true : false}
                isQuickDriverPlannScreen={this.state.isQuickDriverPlannScreen}
                isQuickDriverPlannScreenClick={this.handleIsQuickDriverPlannScreenClickAfterUpdate}
              />
            </div>
            :
            null
          }
          {this.state.showJobUserTaskScheduler ?
            <div className="job-scheduler-container">
              <button
                className="btn btn-lg btn-danger close-job-scheduler-button"
                onClick={(e) => {
                this.setState({
                  showJobUserTaskScheduler: !this.state.showJobUserTaskScheduler
                });
              }}>-</button>
              <PortalJobUserTask
                jobId={this.state.data.id}
                data={this.state.data}
                selectedOption={this.state.data.user_details}
                user_task_instruction_detail={(this.state.data.user_instruction_detail &&
                this.state.data.user_instruction_detail.user_task_instruction_detail)
                ? this.state.data.user_instruction_detail.user_task_instruction_detail : ''
              }
                isLoading={false}
                schedulerHide={this.handleSchedulerHideUserTask}
                isQuickDriverPlannScreenUserTask={this.state.isQuickDriverPlannScreenUserTask}
                isQuickDriverPlannScreenClickUserTask={this.handleIsQuickDriverPlannScreenClickAfterUpdateUserTask}
              />
            </div>
            :
            null
          }
          {
            this.state.showJobNoteBox ?
            <div className="job-scheduler-container">
              <RegNoteBox
                jobId={this.state.data.id}
                data={this.state.data}
                handleHideRegNoteBox={this.handleHideRegNoteBox}
              />
            </div>
              :
              null
          }
          {this.state.showFullJobDetails ?
            <JobFullDetails
              key={'job-'+this.state.data.id+'-fd'}
              data={this.state.data}
              hasSplitParent={hasSplitParent}
              isSplitJob={isSplitJob}
              hasSplitJobs={hasSplitJobs}
              isSplitJobPartA={isSplitJobPartA}
              isSplitJobPartB={isSplitJobPartB}
              customerAllJobsPage={customerAllJobsPage}
            />
            :
            null
          }
        </div>
      </Animate>
      </div>
    )
  }
}